/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * ProVersion Platform API
 * RECORTE GERADO — nao editar. Produzido por front/scripts/normative-contract.mjs
 * a partir de contract/openapi.yaml, contendo apenas operacoes `x-maturity: normative`.
 *
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApproveBatchRequest,
  AttachReceiptRequest,
  BadRequestResponse,
  ConflictResponse,
  CreatePayrollAdjustmentRequest,
  CreatePayrollBatchRequest,
  EarningsSummary,
  ForbiddenResponse,
  GetMyEarningsParams,
  GetStatementParams,
  ListPayrollBatchesParams,
  NotFoundResponse,
  PayBatchRequest,
  PayrollApproval,
  PayrollBatch,
  PayrollBatchDetail,
  PayrollBatchPage,
  PayrollItemState,
  PayrollItemView,
  PayrollStatement,
  PutTeacherRateRequest,
  ReceiptUpload,
  ScheduleBatchRequest,
  ServiceUnavailableResponse,
  SignedURL,
  TeacherRate,
  UnauthorizedResponse,
  UnprocessableEntityResponse
} from '../model';

import { apiFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetOccurrencePayrollItemUrl = (occurrenceId: string,) => {




  return `/v1/occurrences/${occurrenceId}/payroll-item`
}

/**
 * revisao, aprovacao, pagamento e comprovante sao Onda 4, e o valor por
 * aula esta bloqueado pela §15.2.
 *
 * O item referencia a ocorrencia e nao o aluno: dupla e individual geram um
 * item so. E o que faz "uma aula, um pagamento, sempre" ser estrutural.
 * @summary Le o estado do item de folha derivado de uma ocorrencia
 */
export const getOccurrencePayrollItem = async (occurrenceId: string, options?: Parameters<typeof apiFetch>[1]): Promise<PayrollItemState> => {

  return apiFetch<PayrollItemState>(getGetOccurrencePayrollItemUrl(occurrenceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOccurrencePayrollItemQueryKey = (occurrenceId: string,) => {
    return [
    `/v1/occurrences/${occurrenceId}/payroll-item`
    ] as const;
    }


export const getGetOccurrencePayrollItemQueryOptions = <TData = Awaited<ReturnType<typeof getOccurrencePayrollItem>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(occurrenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOccurrencePayrollItem>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOccurrencePayrollItemQueryKey(occurrenceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOccurrencePayrollItem>>> = ({ signal }) => getOccurrencePayrollItem(occurrenceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: occurrenceId !== null && occurrenceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOccurrencePayrollItem>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOccurrencePayrollItemQueryResult = NonNullable<Awaited<ReturnType<typeof getOccurrencePayrollItem>>>
export type GetOccurrencePayrollItemQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse


export function useGetOccurrencePayrollItem<TData = Awaited<ReturnType<typeof getOccurrencePayrollItem>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 occurrenceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOccurrencePayrollItem>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOccurrencePayrollItem>>,
          TError,
          Awaited<ReturnType<typeof getOccurrencePayrollItem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOccurrencePayrollItem<TData = Awaited<ReturnType<typeof getOccurrencePayrollItem>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 occurrenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOccurrencePayrollItem>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOccurrencePayrollItem>>,
          TError,
          Awaited<ReturnType<typeof getOccurrencePayrollItem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOccurrencePayrollItem<TData = Awaited<ReturnType<typeof getOccurrencePayrollItem>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 occurrenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOccurrencePayrollItem>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Le o estado do item de folha derivado de uma ocorrencia
 */

export function useGetOccurrencePayrollItem<TData = Awaited<ReturnType<typeof getOccurrencePayrollItem>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 occurrenceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOccurrencePayrollItem>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOccurrencePayrollItemQueryOptions(occurrenceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyEarningsUrl = (params: GetMyEarningsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/me/earnings?${stringifiedParams}` : `/v1/me/earnings`
}

/**
 * Ganhos do professor autenticado num periodo: aulas elegiveis, valor por
 * aula congelado, ajustes e total estimado, com o estado do lote.
 *
 * O **valor por aula esta aberto na §15.2** e nasce provisorio em um
 * centavo; enquanto o valor for provisorio, a aprovacao de lote responde
 * 503.
 *
 * O professor recebe por aula dada, nao por aluno: individual e dupla pagam
 * o mesmo valor.
 *
 * O estado do lote e o comprovante vem em `batchId`, `batchState` e
 * `receipt`, e sao o lote deste mesmo professor nesta mesma competencia.
 * Os bytes do comprovante saem de `createBatchReceiptDownloadURL`.
 * @summary Ganhos do proprio professor
 */
export const getMyEarnings = async (params: GetMyEarningsParams, options?: Parameters<typeof apiFetch>[1]): Promise<EarningsSummary> => {

  return apiFetch<EarningsSummary>(getGetMyEarningsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyEarningsQueryKey = (params?: GetMyEarningsParams,) => {
    return [
    `/v1/me/earnings`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMyEarningsQueryOptions = <TData = Awaited<ReturnType<typeof getMyEarnings>>, TError = UnauthorizedResponse | ForbiddenResponse>(params: GetMyEarningsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyEarnings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyEarningsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyEarnings>>> = ({ signal }) => getMyEarnings(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyEarnings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyEarningsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyEarnings>>>
export type GetMyEarningsQueryError = UnauthorizedResponse | ForbiddenResponse


export function useGetMyEarnings<TData = Awaited<ReturnType<typeof getMyEarnings>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: GetMyEarningsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyEarnings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyEarnings>>,
          TError,
          Awaited<ReturnType<typeof getMyEarnings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyEarnings<TData = Awaited<ReturnType<typeof getMyEarnings>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: GetMyEarningsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyEarnings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyEarnings>>,
          TError,
          Awaited<ReturnType<typeof getMyEarnings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyEarnings<TData = Awaited<ReturnType<typeof getMyEarnings>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: GetMyEarningsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyEarnings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Ganhos do proprio professor
 */

export function useGetMyEarnings<TData = Awaited<ReturnType<typeof getMyEarnings>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: GetMyEarningsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyEarnings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyEarningsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetTeacherRateUrl = (teacherId: string,) => {




  return `/v1/teachers/${teacherId}/rate`
}

/**
 * Le o valor por aula vigente de um professor. O valor por aula esta aberto
 * na §15.2.
 *
 * Exclusiva de Super Admin. O valor tem historico: alterar hoje nao muda
 * aula ja apurada, porque o valor e congelado na apuracao.
 * @summary Le o valor por aula vigente de um professor
 */
export const getTeacherRate = async (teacherId: string, options?: Parameters<typeof apiFetch>[1]): Promise<TeacherRate> => {

  return apiFetch<TeacherRate>(getGetTeacherRateUrl(teacherId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeacherRateQueryKey = (teacherId: string,) => {
    return [
    `/v1/teachers/${teacherId}/rate`
    ] as const;
    }


export const getGetTeacherRateQueryOptions = <TData = Awaited<ReturnType<typeof getTeacherRate>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(teacherId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeacherRate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeacherRateQueryKey(teacherId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeacherRate>>> = ({ signal }) => getTeacherRate(teacherId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teacherId !== null && teacherId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeacherRate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeacherRateQueryResult = NonNullable<Awaited<ReturnType<typeof getTeacherRate>>>
export type GetTeacherRateQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse


export function useGetTeacherRate<TData = Awaited<ReturnType<typeof getTeacherRate>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 teacherId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeacherRate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherRate>>,
          TError,
          Awaited<ReturnType<typeof getTeacherRate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeacherRate<TData = Awaited<ReturnType<typeof getTeacherRate>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 teacherId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeacherRate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeacherRate>>,
          TError,
          Awaited<ReturnType<typeof getTeacherRate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeacherRate<TData = Awaited<ReturnType<typeof getTeacherRate>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 teacherId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeacherRate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Le o valor por aula vigente de um professor
 */

export function useGetTeacherRate<TData = Awaited<ReturnType<typeof getTeacherRate>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 teacherId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeacherRate>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeacherRateQueryOptions(teacherId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPutTeacherRateUrl = (teacherId: string,) => {




  return `/v1/teachers/${teacherId}/rate`
}

/**
 * Define o valor por aula de um professor. O valor por aula esta aberto na
 * §15.2.
 *
 * Exclusiva de Super Admin e sensivel. Grava uma vigencia nova; nao
 * sobrescreve a anterior.
 * @summary Define o valor por aula de um professor
 */
export const putTeacherRate = async (teacherId: string,
    putTeacherRateRequest: PutTeacherRateRequest, options?: Parameters<typeof apiFetch>[1]): Promise<TeacherRate> => {

  return apiFetch<TeacherRate>(getPutTeacherRateUrl(teacherId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putTeacherRateRequest)
  }
);}





export const getPutTeacherRateMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeacherRate>>, TError,{teacherId: string;data: PutTeacherRateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putTeacherRate>>, TError,{teacherId: string;data: PutTeacherRateRequest}, TContext> => {

const mutationKey = ['putTeacherRate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTeacherRate>>, {teacherId: string;data: PutTeacherRateRequest}> = (props) => {
          const {teacherId,data} = props ?? {};

          return  putTeacherRate(teacherId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTeacherRateMutationResult = NonNullable<Awaited<ReturnType<typeof putTeacherRate>>>
    export type PutTeacherRateMutationBody = PutTeacherRateRequest
    export type PutTeacherRateMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse

    /**
 * @summary Define o valor por aula de um professor
 */
export const usePutTeacherRate = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTeacherRate>>, TError,{teacherId: string;data: PutTeacherRateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTeacherRate>>,
        TError,
        {teacherId: string;data: PutTeacherRateRequest},
        TContext
      > => {
      return useMutation(getPutTeacherRateMutationOptions(options), queryClient);
    }
    export const getListPayrollBatchesUrl = (params?: ListPayrollBatchesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/payroll/batches?${stringifiedParams}` : `/v1/payroll/batches`
}

/**
 * Lista os lotes de folha, com filtro por estado, competencia e professor.
 * Exclusiva de Super Admin. Fechamento mensal e operacao por competencia:
 * sem o filtro, a tela de fechamento pagina o historico inteiro para achar
 * os lotes do mes.
 * @summary Lista lotes de folha
 */
export const listPayrollBatches = async (params?: ListPayrollBatchesParams, options?: Parameters<typeof apiFetch>[1]): Promise<PayrollBatchPage> => {

  return apiFetch<PayrollBatchPage>(getListPayrollBatchesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPayrollBatchesQueryKey = (params?: ListPayrollBatchesParams,) => {
    return [
    `/v1/payroll/batches`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPayrollBatchesQueryOptions = <TData = Awaited<ReturnType<typeof listPayrollBatches>>, TError = UnauthorizedResponse | ForbiddenResponse>(params?: ListPayrollBatchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayrollBatches>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPayrollBatchesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPayrollBatches>>> = ({ signal }) => listPayrollBatches(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPayrollBatches>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPayrollBatchesQueryResult = NonNullable<Awaited<ReturnType<typeof listPayrollBatches>>>
export type ListPayrollBatchesQueryError = UnauthorizedResponse | ForbiddenResponse


export function useListPayrollBatches<TData = Awaited<ReturnType<typeof listPayrollBatches>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params: undefined |  ListPayrollBatchesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayrollBatches>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPayrollBatches>>,
          TError,
          Awaited<ReturnType<typeof listPayrollBatches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayrollBatches<TData = Awaited<ReturnType<typeof listPayrollBatches>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListPayrollBatchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayrollBatches>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPayrollBatches>>,
          TError,
          Awaited<ReturnType<typeof listPayrollBatches>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayrollBatches<TData = Awaited<ReturnType<typeof listPayrollBatches>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListPayrollBatchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayrollBatches>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista lotes de folha
 */

export function useListPayrollBatches<TData = Awaited<ReturnType<typeof listPayrollBatches>>, TError = UnauthorizedResponse | ForbiddenResponse>(
 params?: ListPayrollBatchesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayrollBatches>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPayrollBatchesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreatePayrollBatchUrl = () => {




  return `/v1/payroll/batches`
}

/**
 * Abre a apuracao de um lote de folha por competencia. A competencia e
 * mensal; nenhum documento fixa o dia de corte, e o valor adotado esta
 * registrado no roadmap para ratificacao.
 * @summary Abre a apuracao de um lote de competencia
 */
export const createPayrollBatch = async (createPayrollBatchRequest: CreatePayrollBatchRequest, options?: Parameters<typeof apiFetch>[1]): Promise<PayrollBatch> => {

  return apiFetch<PayrollBatch>(getCreatePayrollBatchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createPayrollBatchRequest)
  }
);}





export const getCreatePayrollBatchMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPayrollBatch>>, TError,{data: CreatePayrollBatchRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPayrollBatch>>, TError,{data: CreatePayrollBatchRequest}, TContext> => {

const mutationKey = ['createPayrollBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPayrollBatch>>, {data: CreatePayrollBatchRequest}> = (props) => {
          const {data} = props ?? {};

          return  createPayrollBatch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePayrollBatchMutationResult = NonNullable<Awaited<ReturnType<typeof createPayrollBatch>>>
    export type CreatePayrollBatchMutationBody = CreatePayrollBatchRequest
    export type CreatePayrollBatchMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse

    /**
 * @summary Abre a apuracao de um lote de competencia
 */
export const useCreatePayrollBatch = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPayrollBatch>>, TError,{data: CreatePayrollBatchRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPayrollBatch>>,
        TError,
        {data: CreatePayrollBatchRequest},
        TContext
      > => {
      return useMutation(getCreatePayrollBatchMutationOptions(options), queryClient);
    }
    export const getGetPayrollBatchUrl = (batchId: string,) => {




  return `/v1/payroll/batches/${batchId}`
}

/**
 * Detalha um lote de folha com seus itens, ajustes, aprovacao, liquidacao e
 * comprovante. Exclusiva de Super Admin.
 * @summary Detalha um lote de folha e seus itens
 */
export const getPayrollBatch = async (batchId: string, options?: Parameters<typeof apiFetch>[1]): Promise<PayrollBatchDetail> => {

  return apiFetch<PayrollBatchDetail>(getGetPayrollBatchUrl(batchId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPayrollBatchQueryKey = (batchId: string,) => {
    return [
    `/v1/payroll/batches/${batchId}`
    ] as const;
    }


export const getGetPayrollBatchQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollBatch>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollBatch>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollBatchQueryKey(batchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollBatch>>> = ({ signal }) => getPayrollBatch(batchId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: batchId !== null && batchId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollBatch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayrollBatchQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollBatch>>>
export type GetPayrollBatchQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse


export function useGetPayrollBatch<TData = Awaited<ReturnType<typeof getPayrollBatch>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 batchId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollBatch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollBatch>>,
          TError,
          Awaited<ReturnType<typeof getPayrollBatch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollBatch<TData = Awaited<ReturnType<typeof getPayrollBatch>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollBatch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollBatch>>,
          TError,
          Awaited<ReturnType<typeof getPayrollBatch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollBatch<TData = Awaited<ReturnType<typeof getPayrollBatch>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollBatch>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha um lote de folha e seus itens
 */

export function useGetPayrollBatch<TData = Awaited<ReturnType<typeof getPayrollBatch>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 batchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollBatch>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayrollBatchQueryOptions(batchId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSubmitBatchForReviewUrl = (batchId: string,) => {




  return `/v1/payroll/batches/${batchId}/review`
}

/**
 * Submete um lote apurado para revisao. Move o lote de `accruing` para
 * `in_review`.
 * @summary Submete um lote apurado para revisao
 */
export const submitBatchForReview = async (batchId: string, options?: Parameters<typeof apiFetch>[1]): Promise<PayrollBatch> => {

  return apiFetch<PayrollBatch>(getSubmitBatchForReviewUrl(batchId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSubmitBatchForReviewMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitBatchForReview>>, TError,{batchId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitBatchForReview>>, TError,{batchId: string}, TContext> => {

const mutationKey = ['submitBatchForReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitBatchForReview>>, {batchId: string}> = (props) => {
          const {batchId} = props ?? {};

          return  submitBatchForReview(batchId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitBatchForReviewMutationResult = NonNullable<Awaited<ReturnType<typeof submitBatchForReview>>>

    export type SubmitBatchForReviewMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse

    /**
 * @summary Submete um lote apurado para revisao
 */
export const useSubmitBatchForReview = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitBatchForReview>>, TError,{batchId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitBatchForReview>>,
        TError,
        {batchId: string},
        TContext
      > => {
      return useMutation(getSubmitBatchForReviewMutationOptions(options), queryClient);
    }
    export const getApproveBatchUrl = (batchId: string,) => {




  return `/v1/payroll/batches/${batchId}/approval`
}

/**
 * Aprova um lote de folha, criando um registro de aprovacao com autor e
 * instante. O valor por aula esta aberto na §15.2 — enquanto ele for
 * provisorio, esta operacao responde 503.
 *
 * Exclusiva de Super Admin e sensivel. **A aprovacao e um recurso, nao um
 * verbo em `PATCH`**: quem aprovou e um dado de primeira classe, porque a
 * regra "ninguem aprova o proprio pagamento" e uma regra sobre quem. Um
 * `PATCH` que mudasse o estado para `approved` nao teria onde guardar isso.
 *
 * Quando o aprovador e beneficiario do lote, a resposta e 403.
 * @summary Aprova um lote de folha
 */
export const approveBatch = async (batchId: string,
    approveBatchRequest: ApproveBatchRequest, options?: Parameters<typeof apiFetch>[1]): Promise<PayrollApproval> => {

  return apiFetch<PayrollApproval>(getApproveBatchUrl(batchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(approveBatchRequest)
  }
);}





export const getApproveBatchMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveBatch>>, TError,{batchId: string;data: ApproveBatchRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveBatch>>, TError,{batchId: string;data: ApproveBatchRequest}, TContext> => {

const mutationKey = ['approveBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveBatch>>, {batchId: string;data: ApproveBatchRequest}> = (props) => {
          const {batchId,data} = props ?? {};

          return  approveBatch(batchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveBatchMutationResult = NonNullable<Awaited<ReturnType<typeof approveBatch>>>
    export type ApproveBatchMutationBody = ApproveBatchRequest
    export type ApproveBatchMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | ServiceUnavailableResponse

    /**
 * @summary Aprova um lote de folha
 */
export const useApproveBatch = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveBatch>>, TError,{batchId: string;data: ApproveBatchRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveBatch>>,
        TError,
        {batchId: string;data: ApproveBatchRequest},
        TContext
      > => {
      return useMutation(getApproveBatchMutationOptions(options), queryClient);
    }
    export const getScheduleBatchUrl = (batchId: string,) => {




  return `/v1/payroll/batches/${batchId}/schedule`
}

/**
 * Agenda o pagamento de um lote aprovado. Exclusiva de Super Admin e
 * sensivel.
 * @summary Agenda o pagamento de um lote aprovado
 */
export const scheduleBatch = async (batchId: string,
    scheduleBatchRequest: ScheduleBatchRequest, options?: Parameters<typeof apiFetch>[1]): Promise<PayrollBatch> => {

  return apiFetch<PayrollBatch>(getScheduleBatchUrl(batchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(scheduleBatchRequest)
  }
);}





export const getScheduleBatchMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleBatch>>, TError,{batchId: string;data: ScheduleBatchRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof scheduleBatch>>, TError,{batchId: string;data: ScheduleBatchRequest}, TContext> => {

const mutationKey = ['scheduleBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scheduleBatch>>, {batchId: string;data: ScheduleBatchRequest}> = (props) => {
          const {batchId,data} = props ?? {};

          return  scheduleBatch(batchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScheduleBatchMutationResult = NonNullable<Awaited<ReturnType<typeof scheduleBatch>>>
    export type ScheduleBatchMutationBody = ScheduleBatchRequest
    export type ScheduleBatchMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | ServiceUnavailableResponse

    /**
 * @summary Agenda o pagamento de um lote aprovado
 */
export const useScheduleBatch = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleBatch>>, TError,{batchId: string;data: ScheduleBatchRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof scheduleBatch>>,
        TError,
        {batchId: string;data: ScheduleBatchRequest},
        TContext
      > => {
      return useMutation(getScheduleBatchMutationOptions(options), queryClient);
    }
    export const getPayBatchUrl = (batchId: string,) => {




  return `/v1/payroll/batches/${batchId}/payment`
}

/**
 * Marca um lote agendado como pago.
 *
 * Exclusiva de Super Admin e sensivel. **O pagamento em si acontece fora da
 * plataforma**, por definicao; esta operacao registra que ele ocorreu. A
 * execucao e idempotente pela chave enviada: repetir a chamada com a mesma
 * chave nao paga duas vezes.
 *
 * E aqui que se diz **como** o professor foi pago: `method` e `reference`
 * sao atributos do mesmo fato que `paidAt`, e por isso entram no corpo
 * desta operacao em vez de numa operacao propria. Uma operacao separada
 * criaria um segundo caminho de escrita para a mesma linha, com a sua
 * propria idempotencia e o seu proprio guarda de estado, e permitiria que
 * um lote ficasse pago para sempre sem que ninguem tivesse dito como — que
 * e exatamente a lacuna que este corpo fecha. Os dois campos sao opcionais;
 * a razao esta em `PayBatchRequest`.
 * @summary Marca um lote como pago
 */
export const payBatch = async (batchId: string,
    payBatchRequest: PayBatchRequest, options?: Parameters<typeof apiFetch>[1]): Promise<PayrollBatch> => {

  return apiFetch<PayrollBatch>(getPayBatchUrl(batchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(payBatchRequest)
  }
);}





export const getPayBatchMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof payBatch>>, TError,{batchId: string;data: PayBatchRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof payBatch>>, TError,{batchId: string;data: PayBatchRequest}, TContext> => {

const mutationKey = ['payBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof payBatch>>, {batchId: string;data: PayBatchRequest}> = (props) => {
          const {batchId,data} = props ?? {};

          return  payBatch(batchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PayBatchMutationResult = NonNullable<Awaited<ReturnType<typeof payBatch>>>
    export type PayBatchMutationBody = PayBatchRequest
    export type PayBatchMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | ServiceUnavailableResponse

    /**
 * @summary Marca um lote como pago
 */
export const usePayBatch = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof payBatch>>, TError,{batchId: string;data: PayBatchRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof payBatch>>,
        TError,
        {batchId: string;data: PayBatchRequest},
        TContext
      > => {
      return useMutation(getPayBatchMutationOptions(options), queryClient);
    }
    export const getAttachBatchReceiptUrl = (batchId: string,) => {




  return `/v1/payroll/batches/${batchId}/receipts`
}

/**
 * Anexa o comprovante de pagamento de um lote, por upload em URL assinada.
 * Emitir a URL **nao** liquida o lote: quem liquida e
 * `confirmBatchReceipt`, depois do envio.
 *
 * Exclusiva de Super Admin e sensivel. O comprovante tem retencao
 * permanente, ao contrario do PDF derivado, que dura 7 dias.
 *
 * Assim como nos materiais, o contrato nao tem campo de nome de arquivo
 * original: o objeto e nomeado pelo servidor.
 * @summary Anexa o comprovante de pagamento de um lote
 */
export const attachBatchReceipt = async (batchId: string,
    attachReceiptRequest: AttachReceiptRequest, options?: Parameters<typeof apiFetch>[1]): Promise<ReceiptUpload> => {

  return apiFetch<ReceiptUpload>(getAttachBatchReceiptUrl(batchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(attachReceiptRequest)
  }
);}





export const getAttachBatchReceiptMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachBatchReceipt>>, TError,{batchId: string;data: AttachReceiptRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof attachBatchReceipt>>, TError,{batchId: string;data: AttachReceiptRequest}, TContext> => {

const mutationKey = ['attachBatchReceipt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof attachBatchReceipt>>, {batchId: string;data: AttachReceiptRequest}> = (props) => {
          const {batchId,data} = props ?? {};

          return  attachBatchReceipt(batchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AttachBatchReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof attachBatchReceipt>>>
    export type AttachBatchReceiptMutationBody = AttachReceiptRequest
    export type AttachBatchReceiptMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse

    /**
 * @summary Anexa o comprovante de pagamento de um lote
 */
export const useAttachBatchReceipt = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof attachBatchReceipt>>, TError,{batchId: string;data: AttachReceiptRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof attachBatchReceipt>>,
        TError,
        {batchId: string;data: AttachReceiptRequest},
        TContext
      > => {
      return useMutation(getAttachBatchReceiptMutationOptions(options), queryClient);
    }
    export const getConfirmBatchReceiptUrl = (batchId: string,
    receiptId: string,) => {




  return `/v1/payroll/batches/${batchId}/receipts/${receiptId}/confirmation`
}

/**
 * Confirma que o comprovante foi de fato enviado pela URL assinada e move
 * o lote de `paid` para `settled`.
 *
 * **A confirmacao e separada do anexo de proposito.** A URL assinada pode
 * ser emitida e nunca usada — o navegador fecha, o upload falha, alguem
 * desiste no meio. Se o anexo ja liquidasse o lote, `settled` passaria a
 * significar "alguem pediu uma URL", e lote liquidado sem comprovante no
 * bucket e liquidacao sem prova. Confirmar depois do envio e o que faz o
 * estado significar o que ele diz.
 *
 * Exclusiva de Super Admin e sensivel: exige reautenticacao recente.
 * @summary Confirma o envio do comprovante e liquida o lote
 */
export const confirmBatchReceipt = async (batchId: string,
    receiptId: string, options?: Parameters<typeof apiFetch>[1]): Promise<PayrollBatch> => {

  return apiFetch<PayrollBatch>(getConfirmBatchReceiptUrl(batchId,receiptId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getConfirmBatchReceiptMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmBatchReceipt>>, TError,{batchId: string;receiptId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmBatchReceipt>>, TError,{batchId: string;receiptId: string}, TContext> => {

const mutationKey = ['confirmBatchReceipt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmBatchReceipt>>, {batchId: string;receiptId: string}> = (props) => {
          const {batchId,receiptId} = props ?? {};

          return  confirmBatchReceipt(batchId,receiptId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmBatchReceiptMutationResult = NonNullable<Awaited<ReturnType<typeof confirmBatchReceipt>>>

    export type ConfirmBatchReceiptMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse

    /**
 * @summary Confirma o envio do comprovante e liquida o lote
 */
export const useConfirmBatchReceipt = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmBatchReceipt>>, TError,{batchId: string;receiptId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmBatchReceipt>>,
        TError,
        {batchId: string;receiptId: string},
        TContext
      > => {
      return useMutation(getConfirmBatchReceiptMutationOptions(options), queryClient);
    }
    export const getCreateBatchReceiptDownloadURLUrl = (batchId: string,
    receiptId: string,) => {




  return `/v1/payroll/batches/${batchId}/receipts/${receiptId}/download-url`
}

/**
 * Emite uma URL assinada de curta duracao para o comprovante de pagamento
 * de um lote. Alcancam esta operacao o **professor beneficiario do lote**
 * e o Super Admin; qualquer outra pessoa recebe 404, como em todo recurso
 * deste contrato que existe mas esta fora do alcance de quem pediu.
 *
 * E a metade que faltava para o professor: `EarningsSummary.receipt` e
 * `PayrollStatement.receipt` dizem que o comprovante existe e desde
 * quando, e esta operacao entrega os bytes. Estao separados pela mesma
 * razao dos materiais e dos anexos — URL assinada dura pouco, e embuti-la
 * no demonstrativo faria cada leitura de tela emitir uma URL que expira
 * antes de alguem clicar.
 *
 * Comprovante anexado e ainda nao confirmado responde 409: a URL de upload
 * pode ter sido emitida e nunca usada, e nesse caso nao ha objeto no
 * bucket para assinar.
 * @summary Emite URL assinada de download do comprovante de um lote
 */
export const createBatchReceiptDownloadURL = async (batchId: string,
    receiptId: string, options?: Parameters<typeof apiFetch>[1]): Promise<SignedURL> => {

  return apiFetch<SignedURL>(getCreateBatchReceiptDownloadURLUrl(batchId,receiptId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getCreateBatchReceiptDownloadURLMutationOptions = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBatchReceiptDownloadURL>>, TError,{batchId: string;receiptId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBatchReceiptDownloadURL>>, TError,{batchId: string;receiptId: string}, TContext> => {

const mutationKey = ['createBatchReceiptDownloadURL'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBatchReceiptDownloadURL>>, {batchId: string;receiptId: string}> = (props) => {
          const {batchId,receiptId} = props ?? {};

          return  createBatchReceiptDownloadURL(batchId,receiptId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBatchReceiptDownloadURLMutationResult = NonNullable<Awaited<ReturnType<typeof createBatchReceiptDownloadURL>>>

    export type CreateBatchReceiptDownloadURLMutationError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse

    /**
 * @summary Emite URL assinada de download do comprovante de um lote
 */
export const useCreateBatchReceiptDownloadURL = <TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBatchReceiptDownloadURL>>, TError,{batchId: string;receiptId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBatchReceiptDownloadURL>>,
        TError,
        {batchId: string;receiptId: string},
        TContext
      > => {
      return useMutation(getCreateBatchReceiptDownloadURLMutationOptions(options), queryClient);
    }
    export const getCreateItemAdjustmentUrl = (payrollItemId: string,) => {




  return `/v1/payroll/items/${payrollItemId}/adjustments`
}

/**
 * Ajusta o valor de um item de folha, com justificativa obrigatoria.
 *
 * Exclusiva de Super Admin e sensivel. Como na presenca, o ajuste fica **ao
 * lado** do valor apurado: `computedAmount` permanece intacto e
 * `adjustedAmount` registra a diferenca, com autor, instante e
 * justificativa. Justificativa vazia e recusada com 422.
 * @summary Ajusta o valor de um item de folha, com justificativa
 */
export const createItemAdjustment = async (payrollItemId: string,
    createPayrollAdjustmentRequest: CreatePayrollAdjustmentRequest, options?: Parameters<typeof apiFetch>[1]): Promise<PayrollItemView> => {

  return apiFetch<PayrollItemView>(getCreateItemAdjustmentUrl(payrollItemId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createPayrollAdjustmentRequest)
  }
);}





export const getCreateItemAdjustmentMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createItemAdjustment>>, TError,{payrollItemId: string;data: CreatePayrollAdjustmentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createItemAdjustment>>, TError,{payrollItemId: string;data: CreatePayrollAdjustmentRequest}, TContext> => {

const mutationKey = ['createItemAdjustment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createItemAdjustment>>, {payrollItemId: string;data: CreatePayrollAdjustmentRequest}> = (props) => {
          const {payrollItemId,data} = props ?? {};

          return  createItemAdjustment(payrollItemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateItemAdjustmentMutationResult = NonNullable<Awaited<ReturnType<typeof createItemAdjustment>>>
    export type CreateItemAdjustmentMutationBody = CreatePayrollAdjustmentRequest
    export type CreateItemAdjustmentMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse

    /**
 * @summary Ajusta o valor de um item de folha, com justificativa
 */
export const useCreateItemAdjustment = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createItemAdjustment>>, TError,{payrollItemId: string;data: CreatePayrollAdjustmentRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createItemAdjustment>>,
        TError,
        {payrollItemId: string;data: CreatePayrollAdjustmentRequest},
        TContext
      > => {
      return useMutation(getCreateItemAdjustmentMutationOptions(options), queryClient);
    }
    export const getGetStatementUrl = (period: string,
    params?: GetStatementParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/payroll/statements/${period}?${stringifiedParams}` : `/v1/payroll/statements/${period}`
}

/**
 * Demonstrativo de uma competencia: aulas elegiveis com data e tipo, valor
 * unitario congelado, ajustes com motivo, total, estado e comprovante.
 *
 * Professor le o proprio; Super Admin le o de qualquer um, informando
 * `teacherId`.
 *
 * O estado e o comprovante prometidos acima sao `batchState` e `receipt`,
 * e o download do comprovante e `createBatchReceiptDownloadURL`. Ate a
 * correcao da Onda 4 esta descricao prometia os dois e o schema nao os
 * tinha, o que deixava a tela de ganhos sem como cumprir a propria tarefa.
 *
 * **O demonstrativo nao mostra nome de aluno, nem mascarado.** O item de
 * folha referencia a ocorrencia, nao o aluno: a lista mostra data, horario
 * e tipo da aula, e nada que identifique uma pessoa.
 * @summary Demonstrativo de uma competencia
 */
export const getStatement = async (period: string,
    params?: GetStatementParams, options?: Parameters<typeof apiFetch>[1]): Promise<PayrollStatement> => {

  return apiFetch<PayrollStatement>(getGetStatementUrl(period,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStatementQueryKey = (period: string,
    params?: GetStatementParams,) => {
    return [
    `/v1/payroll/statements/${period}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStatementQueryOptions = <TData = Awaited<ReturnType<typeof getStatement>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(period: string,
    params?: GetStatementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatement>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStatementQueryKey(period,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStatement>>> = ({ signal }) => getStatement(period,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: period !== null && period !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStatement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStatementQueryResult = NonNullable<Awaited<ReturnType<typeof getStatement>>>
export type GetStatementQueryError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse


export function useGetStatement<TData = Awaited<ReturnType<typeof getStatement>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 period: string,
    params: undefined |  GetStatementParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatement>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatement>>,
          TError,
          Awaited<ReturnType<typeof getStatement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatement<TData = Awaited<ReturnType<typeof getStatement>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 period: string,
    params?: GetStatementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatement>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStatement>>,
          TError,
          Awaited<ReturnType<typeof getStatement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStatement<TData = Awaited<ReturnType<typeof getStatement>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 period: string,
    params?: GetStatementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatement>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Demonstrativo de uma competencia
 */

export function useGetStatement<TData = Awaited<ReturnType<typeof getStatement>>, TError = UnauthorizedResponse | ForbiddenResponse | NotFoundResponse>(
 period: string,
    params?: GetStatementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStatement>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStatementQueryOptions(period,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






